{
    "n3v-mnqHfhCDjbDxPtTjW": {
        "tag": "spawngood",
        "key": "n3v-mnqHfhCDjbDxPtTjW",
        "position": {
            "x": 1,
            "y": 1,
            "z": 1
        }
    },
    "sHHTmxZOBmXEB9_XL9AS2": {
        "tag": "spawngood",
        "key": "sHHTmxZOBmXEB9_XL9AS2",
        "position": {
            "x": 1,
            "y": 2,
            "z": 1
        }
    },
    "c83feSoDTrlzxQNpIO-VD": {
        "tag": "spawngood",
        "key": "c83feSoDTrlzxQNpIO-VD",
        "position": {
            "x": 0,
            "y": 6,
            "z": 1
        }
    }
}